module.exports = __webpack_public_path__ + "static/media/1008171.dfef51e7.png";